import { IPackageSellInfo } from '@/Interfaces';
import { isWeekDay } from '@/utils';

export class PackageSellInfoValidator {
  public isValid(value: IPackageSellInfo, status: string): Record<string, string> {
    const validations: Record<string, string> = {};

    if (!value.balanceType || !value.balanceType.id) validations.balanceType = 'Balance Type is required';
    if ((!value.buyer || !value.buyer.id) && !['Sourced', 'Cancelled'].includes(status)) validations.buyer = 'Buyer is required';
    if (!value.includeLoanRights && !value.includePPPRights && !value.includeServicingRights) validations.stripType = 'Strip Type is required';

    // Check if the settled date is after the trade date
    if (value.settledDate && value.tradeDate) {
      const tradeDate = new Date(value.tradeDate);
      const settledDate = new Date(value.settledDate);
      if (settledDate < tradeDate) {
        validations.settledDate = 'Funding Settlement Date cannot be before Trade Date';
      }
    }

    // Check if the settled date is a weekend
    if (value.settledDate) {
      if (!isWeekDay(value.settledDate)) {
        validations.settledDate = 'Funding Settlement date must be a business day';
      }
    }

    return validations;
  }
}